"use client";

import { TableCellsIcon } from "@heroicons/react/24/outline";

import { DetailsTable } from "@/features/analysis/chip/us/insider/components/DetailsTable";
import { useDialog } from "@/hooks/use-dialog";
import { useLang } from "@/hooks/use-lang";

import { Button } from "ui/core/button";

export const InsiderBuyingDialog = ({ symbol }: { symbol: string }) => {
  const { t, lang } = useLang();
  const { Dialog, openDialog, isOpen } = useDialog();

  return (
    <>
      <Button
        variant="secondary"
        className="flex items-center gap-2"
        onClick={openDialog}
        disabled={isOpen}
      >
        <TableCellsIcon className="h-5 w-5" />
        {t.analysis.chip.insider.details}
      </Button>
      <Dialog width={1200}>
        <div className="space-y-2 px-4 py-4 lg:px-6">
          <h2 className="text-lg font-bold">
            {symbol} {t.analysis.chip.insider.detailsOfInsiderTrading}
          </h2>
          <p className="text-zinc-500">
            {t.analysis.chip.insider.dialogDescription}
          </p>
          <DetailsTable lang={lang} symbol={symbol} />
        </div>
      </Dialog>
    </>
  );
};
